import { render, staticRenderFns } from "./CustomDetails.vue?vue&type=template&id=35e91af2"
import script from "./CustomDetails.vue?vue&type=script&lang=js"
export * from "./CustomDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports